/**
 * Renders a headline that colours one phrase mid-sentence, from a SINGLE
 * translatable key. The accented phrase is marked with `[brackets]` in the
 * message:
 *
 *   funnel_sq_h1 = "Get through your [research papers] without reading them."
 *
 * The alternative — `_pre` / `_accent` / `_post` keys concatenated in JSX —
 * bakes English word order into the component. Spanish moves the noun ahead
 * of its modifier, German moves the verb to the end, and a translator handed
 * three fragments has no way to express either. With one key they just move
 * the brackets.
 *
 * Brackets rather than tags because inlang messages are plain strings here
 * (no message in `en.json` contains markup) and `[` never appears in funnel
 * copy. Text outside the brackets renders unstyled.
 */
export function AccentText({
  className,
  text,
}: {
  /** Applied to the bracketed phrase only. */
  className?: string;
  text: string;
}) {
  // A capture group in the separator interleaves the results: even indices are
  // the surrounding literals, odd indices are the bracketed phrases.
  return text.split(/\[(.*?)]/).map((part, index) =>
    index % 2 === 1 ? (
      <span className={className} key={index}>
        {part}
      </span>
    ) : (
      part
    ),
  );
}
